export default __webpack_public_path__ + "assets/lab3.f8f2eede.png";